const entity = {
    create_failed: 'Fallo al crear {{name}}.',
    not_exists: 'El {{name}} no existe.',
    not_exists_with_id: 'El {{name}} con ID `{{id}}` no existe.',
    not_found: 'El recurso no existe.',
};
export default entity;
